import {
  Box,
  Center,
  Flex,
  Heading,
  Image,
  Text,
  Textarea,
  useToast,
  Wrap,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useDisclosure } from "@chakra-ui/react";
import CaptureButton from "../../components/CaptureButton";
import CompanyInfo from "../../components/CompanyInfo";
import RadioButtons from "../../components/RadioButtons";
import PriceBox from "./components/PriceBox";
import RadioButtonsMaterial from "./components/RadioButtonsMaterial";
import PreviewImageModal from "../../components/PreviewImageModal";
import TwoButtonModal from "../../components/TwoButtonModal";
import MenuTipModal from "routes/Requests/components/MenuTipModal";
import { useQuery } from "@tanstack/react-query";
import { getServiceMenu, setImageMint, setItemSet } from "./api";
import { MaterialModel, MenuModel } from "lib/api/model";
import SubMenuList from "./components/SubMenuList";
import { useRecoilState } from "recoil";
import { captureListState } from "lib/atoms/orderState";
import imageCompression from "browser-image-compression";
import history from "router/history";
import { ResStatus } from "lib/api/enum";
import withAuth from "lib/hook/withAuth";
import usePathNavigate from "lib/hook/usePathNavigate";
import RadioButtonsSmMenuList from "./components/RadioButtonsSmMenuList";
import FullScreenLoader from "components/FullScreenLoader";

function RequestOrder() {
  const toast = useToast();
  const { pathNavigate } = usePathNavigate();
  const { data: menuData, isLoading: menuDataLoading } = useQuery(
    ["getServiceMenu"],
    () =>
      getServiceMenu({
        channel: localStorage.getItem("channel") ?? "apps",
      }),
    {
      onError: (err: any) => {
        toast({
          title: "오류",
          description: err.message,
          status: "error",
          duration: 3000,
          isClosable: true,
          position: "top",
        });
      },
    }
  );
  const [captureList, setCaptureList] = useRecoilState(captureListState);
  const [requestsValue, setRequestsValue] = useState("");
  const onChangeRequestsValue = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setRequestsValue(e.target.value);
  };

  const [categoryMenu, setCategoryMenu] = useState<string[]>([]);
  const [materiallList, setMaterialList] = useState<MaterialModel[]>([]);
  const [subMenuList, setSubMenuList] = useState<MenuModel[]>([]);
  const [menuIdList, setMenuIdList] = useState<number[]>([]);
  const [categoryId, setCategoryId] = useState(-1);
  const [materialId, setMaterialId] = useState(-1);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [isLoading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    const listenBackEvent = () => {
      setCaptureList([]);
    };
    const unlistenHistoryEvent = history.listen(({ action }) => {
      if (action === "POP") {
        listenBackEvent();
      }
    });
    return unlistenHistoryEvent;
  }, [history]);

  const InitMenuListForSmcare = () => {
    const sm_category_id = 2;
    const menuList = menuData?.command.menu.filter(
      (menu) => menu.category_id === sm_category_id && menu.price > 0
    );
    if (menuList !== undefined && menuList.length > 0) {
      const changeNameList = menuList.map((menu: MenuModel) => {
        if (menu.id === 27390) {
          menu.name = "아웃도어";
        } else if (menu.id === 28390) {
          menu.name = "런닝·골프화";
        } else if (menu.id === 29390) {
          menu.name = "농구·보드화";
        }
        return menu;
      });
      // console.log(changeNameList);
      setSubMenuList(changeNameList);
    }
  };
  const InitMenuListForCosmocare = () => {
    console.log(menuData);
    const cosmo_category_id = 2;
    const menuList = menuData?.command.menu.filter(
      (menu) => menu.category_id === cosmo_category_id && menu.price > 0
    );
    if (menuList !== undefined && menuList.length > 0) {
      const changeNameList = menuList.map((menu: MenuModel) => {
        if (menu.id === 26390) {
          menu.name = "코스모케어";
        }
        return menu;
      });
      // console.log(changeNameList);
      setSubMenuList(changeNameList);
    }
  };

  useEffect(() => {
    if (!menuDataLoading) {
      if (menuData?.status !== ResStatus.RES_SUCCESS) return;
      // console.log(menuData);
      setCategoryMenu(menuData.command.category.map((menu) => menu.name));
      if (localStorage.getItem("channel") === "smcare") {
        InitMenuListForSmcare();
      } else if (localStorage.getItem("channel") === "cosmocare") {
        InitMenuListForCosmocare();
      }
    }
  }, [menuData, menuDataLoading]);

  const onCategoryHandler = (value: string) => {
    const category = menuData?.command.category.find(
      (menu) => menu.name === value
    );
    if (category !== undefined) {
      const mtlList = menuData?.command.material.filter(
        (menu) => menu.category_id === category.id
      );
      if (mtlList !== undefined && mtlList.length > 0) {
        setCategoryId(category.id);
        setMaterialList(mtlList);
        setMaterialId(-1);
        setSubMenuList([]);
        if (menuIdList !== undefined && menuIdList.length > 0) {
          setMenuIdList([]);
          setCarePrice(0);
          setRepairPrice(0);
          setEnhancePrice(0);
        }
      }
    }
  };
  const onMaterialHandler = (value: string) => {
    const material = menuData?.command.material.find(
      (menu) => menu.name === value
    );
    if (material !== undefined) {
      const menuList = menuData?.command.menu.filter(
        (menu) =>
          menu.category_id === categoryId && menu.material_id === material.id
      );
      if (menuList !== undefined && menuList.length > 0) {
        setMaterialId(material.id);
        setMenuIdList([]);
        setCarePrice(0);
        setRepairPrice(0);
        setEnhancePrice(0);
        setSubMenuList(menuList);
      }
    }
  };

  const uploadImages = async () => {
    if (captureList.length > 0) {
      const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 2048,
        useWebWorker: true,
        fileType: "image/jpeg",
      };
      const responseList = await Promise.all(
        captureList.map(async (pic, index) => {
          const compressedFile = await imageCompression(pic.imageFile, options);
          const base64File: string = await imageCompression.getDataUrlFromFile(
            compressedFile
          );
          const result = await setImageMint({
            files: base64File.replace("data:image/jpeg;base64,", ""),
            contents_type: "order",
          });
          if (result.status !== ResStatus.RES_SUCCESS) {
            return -1;
          }
          return result.command.image_id;
        })
      );
      return responseList;
    }
    return [];
  };
  const onSaveItemHandler = async () => {
    // 제품 저장하기
    // upload image
    setIsSubmitLoading(true);
    try {
      const uploadResults = await uploadImages();
      const imageIdList = uploadResults.filter((imageId) => imageId !== -1);
      console.log("imageIdList", uploadResults, imageIdList);
      if (
        imageIdList &&
        imageIdList.length > 0 &&
        uploadResults.length === imageIdList.length
      ) {
        const result = await setItemSet({
          service_id: menuIdList,
          image_id: imageIdList,
          comment: requestsValue,
          order_price: carePrice + repairPrice + enhancePrice,
        });
        if (result?.status === ResStatus.RES_SUCCESS) {
          setCaptureList([]);
          saveOpen();
        } else {
          toast({
            title: "실패",
            description: result?.status + "/" + result.result_message,
            status: "error",
            duration: 3000,
            isClosable: true,
            position: "top",
          });
          // throw new Error(result?.status + '/' + result.result_message);
        }
      } else {
        toast({
          title: "오류",
          description: "이미지 업로드 실패",
          status: "error",
          duration: 3000,
          isClosable: true,
          position: "top",
        });
        // throw new Error('이미지 업로드 실패');
      }
    } catch (err: any) {
      toast({
        title: "오류-catch",
        description: err.message,
        status: "error",
        duration: 3000,
        isClosable: true,
        position: "top",
      });
    } finally {
      setIsSubmitLoading(false);
    }
  };

  const {
    isOpen: imageIsOpen,
    onClose: imageClose,
    onOpen: imageOpen,
  } = useDisclosure();
  const {
    isOpen: saveIsOpen,
    onClose: saveClose,
    onOpen: saveOpen,
  } = useDisclosure();
  const {
    isOpen: tipIsOpen,
    onClose: tipClose,
    onOpen: tipOpen,
  } = useDisclosure();
  const [previewImage, setPreviewImage] = useState("");
  const onPreviewImage = (previewImage: string) => {
    // console.log(previewImage);
    setPreviewImage(previewImage);
    imageOpen();
  };

  const onGotoAddProduct = async () => {
    // 제품추가하기
    window.location.reload();
  };
  const onGotoOrder = async () => {
    // 주문하러가기
    pathNavigate("/products/list");
  };

  const [tipInfo, setTipInfo] = useState<{
    imagePath: string;
    textTip: string;
    textTitle: string;
  }>({ imagePath: "", textTip: "", textTitle: "" });
  const showInfoDialog = async (
    id: number,
    title: string,
    image: string,
    ratio: number,
    description: string
  ) => {
    setTipInfo({
      textTitle: title,
      textTip: description,
      imagePath: image,
    });
    tipOpen();
  };
  const selectMenu = (id: number) => {
    if (menuIdList.find((element) => element === id) !== undefined) {
      // delete
      const result = menuIdList.filter((element) => element !== id);
      setMenuIdList(result);
      calcPrice(result);
    } else {
      const filterd = subMenuList.filter((sub) => sub.id === id);
      let arrIdx = [...menuIdList];
      if (filterd.length > 0) {
        const disabled = filterd[0].disable
          .split(",")
          .map((element) => +element);
        for (var i = 0; i < disabled.length; i++) {
          const delIdx = menuIdList.find((element) => element === disabled[i]);
          if (delIdx !== undefined)
            arrIdx = arrIdx.filter((element) => element !== delIdx);
        }
      }
      // add
      const result = [...arrIdx, id].sort();
      setMenuIdList(result);
      calcPrice(result);
    }
  };
  const selectSmcareMenu = (value: string) => {
    const fMenu = subMenuList.find((menu) => menu.name === value);
    if (fMenu !== undefined) {
      // console.log('selected', fMenu);
      const idList = [fMenu.id];
      setMenuIdList(idList);
      calcPrice(idList);
    }
  };

  const [carePrice, setCarePrice] = useState(0);
  const [repairPrice, setRepairPrice] = useState(0);
  const [enhancePrice, setEnhancePrice] = useState(0);
  const calcPrice = (selectedMenuList: number[]) => {
    let carePrice = 0;
    let repairPrice = 0;
    let enhancePrice = 0;
    for (var i = 0; i < selectedMenuList.length; i++) {
      const filterd = subMenuList.filter(
        (sub) => sub.id === selectedMenuList[i]
      );
      if (filterd[0].type === "care") carePrice += filterd[0].price;
      else if (filterd[0].type === "repair") repairPrice += filterd[0].price;
      else enhancePrice += filterd[0].price;
    }
    setCarePrice(carePrice);
    setRepairPrice(repairPrice);
    setEnhancePrice(enhancePrice);
  };

  return (
    <Box>
      {isLoading && <FullScreenLoader />}
      <Center my={"18px"} fontSize="20px" fontWeight={"semibold"}>
        서비스 신청
      </Center>
      {true && (
        <>
          {localStorage.getItem("channel") === "smcare" ||
          localStorage.getItem("channel") === "cosmocare" ? (
            <Box my={"20px"} px={"20px"}>
              <Heading
                fontSize={"16px"}
                fontWeight="semibold"
                mb={materiallList ? "16px" : "8px"}
              >
                제품의 종류를 선택하세요.
              </Heading>
              {subMenuList.length > 0 && (
                <RadioButtonsSmMenuList
                  radioGroupName={"smmenulist"}
                  buttonList={subMenuList}
                  buttonSize={{ w: "155px", h: "56px" }}
                  onChange={selectSmcareMenu}
                />
              )}
            </Box>
          ) : (
            <>
              <Box
                alignItems={"flex-start"}
                mt={"36px"}
                mb={"20px"}
                px={"20px"}
              >
                <Heading fontSize={"16px"} fontWeight="semibold" mb={"16px"}>
                  1. 맡기시는 제품의 카테고리를 선택하세요.
                </Heading>
                {categoryMenu && (
                  <RadioButtons
                    radioGroupName="category"
                    buttonList={categoryMenu}
                    buttonSize={{ w: "100px", h: "56px" }}
                    onChange={onCategoryHandler}
                  />
                )}
              </Box>
              <Box w={"100%"} h="8px" bg="#f5f6f8" />
              <Box my={"20px"} px={"20px"}>
                <Heading
                  fontSize={"16px"}
                  fontWeight="semibold"
                  mb={materiallList ? "16px" : "8px"}
                >
                  2. 제품의 주 소재나 종류를 선택하세요.
                </Heading>
                {materiallList.length > 0 ? (
                  <RadioButtonsMaterial
                    radioGroupName={"material"}
                    buttonList={materiallList}
                    buttonSize={{ w: "155px", h: "56px" }}
                    onChange={onMaterialHandler}
                    infoDialog={showInfoDialog}
                  />
                ) : (
                  <Text fontSize={"14px"} color="#9e9e9e">
                    앞 단계를 먼저 선택하세요
                  </Text>
                )}
              </Box>
              <Box w={"100%"} h="8px" bg="#f5f6f8" />
              <Box my={"20px"} px={"20px"}>
                <Heading fontSize={"16px"} fontWeight="semibold">
                  3. 원하시는 서비스를 모두 선택하세요.
                </Heading>
                {subMenuList.length > 0 ? (
                  <>
                    <SubMenuList
                      title={"케어"}
                      menuList={subMenuList?.filter(
                        (sub) => sub.type === "care"
                      )}
                      menuId={menuIdList}
                      selectMenu={selectMenu}
                      infoDialog={showInfoDialog}
                    />
                    <SubMenuList
                      title={"복원"}
                      menuList={subMenuList?.filter(
                        (sub) => sub.type === "repair"
                      )}
                      menuId={menuIdList}
                      selectMenu={selectMenu}
                      infoDialog={showInfoDialog}
                    />
                    {subMenuList?.filter((sub) => sub.type === "enhance")
                      .length > 0 && (
                      <>
                        <SubMenuList
                          title={"보강"}
                          menuList={subMenuList?.filter(
                            (sub) => sub.type === "enhance"
                          )}
                          menuId={menuIdList}
                          selectMenu={selectMenu}
                          infoDialog={showInfoDialog}
                        />
                      </>
                    )}
                  </>
                ) : (
                  <Text fontSize={"14px"} color="#9e9e9e" mt={"8px"}>
                    앞 단계를 먼저 선택하세요
                  </Text>
                )}
              </Box>
            </>
          )}
          <Box w={"100%"} h="8px" bg="#f5f6f8" />
          <Box my={"20px"} px={"20px"}>
            <Heading fontSize={"16px"} fontWeight="semibold" mb={"16px"}>
              {localStorage.getItem("channel") === "smcare" ||
              localStorage.getItem("channel") === "cosmocare"
                ? "제품 사진을 추가해 주세요."
                : "4. 제품 사진을 추가해 주세요."}
            </Heading>
            <Box>
              <Wrap spacing={"5px"} overflow="visible">
                <CaptureButton
                  slotId={0}
                  onPreviewImage={onPreviewImage}
                  setLoading={setLoading}
                />
                <CaptureButton
                  slotId={1}
                  onPreviewImage={onPreviewImage}
                  setLoading={setLoading}
                />
                <CaptureButton
                  slotId={2}
                  onPreviewImage={onPreviewImage}
                  setLoading={setLoading}
                />
                <CaptureButton
                  slotId={3}
                  onPreviewImage={onPreviewImage}
                  setLoading={setLoading}
                />
              </Wrap>
              <Flex mt={"9px"} fontSize="12px" color="#128cfe">
                <Image src="/assets/images/icn_marks_exclamation_blue.svg" />
                <Text fontWeight={"semibold"} ml="4px">
                  최소 2장 이상
                </Text>
                <Text>의 사진을 업로드해 주세요.(최대 4장)</Text>
              </Flex>
            </Box>
          </Box>
        </>
      )}
      <Box w={"100%"} h="8px" bg="#f5f6f8" />
      <Box w="100%" mt={"20px"} px={"20px"}>
        <Heading fontSize={"16px"} fontWeight="semibold" mb={"16px"}>
          {localStorage.getItem("channel") === "smcare" ||
          localStorage.getItem("channel") === "cosmocare"
            ? "추가적인 요청사항을 입력해 주세요. (선택)"
            : "5. 추가적인 요청사항을 입력해 주세요. (선택)"}
        </Heading>
        <Textarea
          w={"100%"}
          h={"108px"}
          mb="19px"
          resize="vertical"
          fontSize={"14px"}
          placeholder="최대 100자까지 작성 가능해요."
          value={requestsValue}
          onChange={onChangeRequestsValue}
          maxLength={100}
        />
      </Box>
      <Box w={"100%"} h="41px" />
      <CompanyInfo />
      <Box h="137px" />
      <PriceBox
        isLoading={isSubmitLoading}
        isDisabled={
          carePrice + repairPrice + enhancePrice <= 0 || captureList.length < 2
        }
        onSaveProduct={onSaveItemHandler}
        carePrice={carePrice}
        repairPrice={repairPrice}
        enhancePrice={enhancePrice}
      />
      <PreviewImageModal
        isOpen={imageIsOpen}
        onClose={imageClose}
        previewImage={previewImage}
      />
      <MenuTipModal
        isOpen={tipIsOpen}
        onClose={tipClose}
        imagePath={tipInfo.imagePath}
        textTitle={tipInfo.textTitle}
        textTip={tipInfo.textTip}
      />
      <TwoButtonModal
        isOpen={saveIsOpen}
        textLeft="제품 추가하기"
        textRight="주문하기"
        onClose={saveClose}
        onClickLeftButton={onGotoAddProduct}
        onClickRightButton={onGotoOrder}
      >
        <Flex
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems="center"
        >
          <Image
            src="/assets/images/icn_circle_check.svg"
            mt="20px"
            boxSize={"56px"}
          />
          <Text mt="14px" fontSize={"15px"} fontWeight="semibold">
            제품이 성공적으로 저장되었어요!
          </Text>
        </Flex>
      </TwoButtonModal>
    </Box>
  );
}
export default withAuth(RequestOrder);
// export default RequestOrder;
